import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '../../../../wag-react/next-components/box';

// Import images directly
import happyDog1 from '../../assets/happy-dogs/happy-dog-1.svg';
import happyDog2 from '../../assets/happy-dogs/happy-dog-2.svg';
import happyDog3 from '../../assets/happy-dogs/happy-dog-3.svg';
import badgeTrusted from '../../assets/happy-dogs/badge-trusted.svg';

// Define the image paths
const dogImages = [happyDog1, happyDog2, happyDog3];
const badgeImage = badgeTrusted;
const CarouselWrapper = styled(Box)`
  position: absolute;
  width: 506px;
  height: 506px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  
  @media (max-width: 960px) {
    width: 406px;
    height: 406px;
  }
  
  @media (max-width: 960px) and (min-width: 833px) {
    transform: translateX(-38%);
  }
  
  @media (max-width: 832px) and (min-width: 769px) {
    transform: translateX(-50%);
  }
  
  @media (max-width: 832px) {
    position: relative;
    width: 100%;
    height: auto;
    max-width: 506px;
    aspect-ratio: 1 / 1;
    left: auto;
    transform: none;
    padding: 10px;
  }
`;
const CarouselContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
`;
const DogImage = styled.img<{
  isActive: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 1s ease-in-out;
  opacity: ${props => props.isActive ? 1 : 0};
`;
const BadgeImage = styled.img`
  position: absolute;
  top: 50px;
  left: 0px;
  width: 120px;
  height: 120px;
  z-index: 10;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 0;
  
  @media (max-width: 832px) {
    width: 80px;
    height: 80px;
    top: 30px;
    left: 10px;
    border: 1px solid white;
  }
`;
const BadgeWrapper = styled(Box)`
  position: absolute;
  top: 50px;
  left: 0px;
  width: 120px;
  height: 120px;
  z-index: 10;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border: 3px solid white;
  
  @media (max-width: 832px) {
    width: 80px;
    height: 80px;
    top: 30px;
    left: 10px;
    border: 2px solid white;
  }
`;
export const HappyDogsCarousel: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Effect to cycle through images every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prevIndex => (prevIndex + 1) % dogImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <CarouselWrapper data-sentry-element="CarouselWrapper" data-sentry-component="HappyDogsCarousel" data-sentry-source-file="index.tsx">
      <CarouselContainer data-sentry-element="CarouselContainer" data-sentry-source-file="index.tsx">
        {dogImages.map((src, index) => <DogImage key={src} src={src} alt={`Happy dog ${index + 1}`} isActive={index === activeIndex} />)}
      </CarouselContainer>
      <BadgeImage src={badgeImage} alt="Trusted by millions of pet parents" data-sentry-element="BadgeImage" data-sentry-source-file="index.tsx" />
      <BadgeWrapper data-sentry-element="BadgeWrapper" data-sentry-source-file="index.tsx" />
    </CarouselWrapper>;
};
export default HappyDogsCarousel;